export enum AvailableServiceOption {
  internet = 'internet',
  tv = 'tv',
  phone = 'phone',
  homeSecurity = 'homeSecurity',
}
